// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__wyUdK","links":"Navbar_links__yCzSO","link":"Navbar_link__2XB7-","active":"Navbar_active__2SZTB"};